import React from 'react';
import { Button, Table } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'


import './RefundModal.css'

function RefundModal(props) {
    


    return (
        <div  >
                <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter" >
           Cancellation Policy
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          <div>
            <h5>Cancelling a room is as fast as booking one</h5>
            <p>
              We would love to host you but in case your plans change, our simple cancellation process
              makes sure you receive a quick confirmation and fast refunds. Our standard check-in time is
              12 PM.
            </p>
            <h5>For bookings up to 3 rooms -</h5>
            <Table responsive stripped bordered hover className='Tableur' >
              <thead className='Tableur-head'>
                  <th>Cancellation Time</th>
                  <th>Cancellation Fee</th>
              </thead>
              <tbody>
                <tr>
                    <td>48 hours or more prior to check-in time</td>
                    <td>Free cancellation (100% refund)</td>
                </tr>
                <tr>
                    <td>Between 48 hours and 24 hours before check-in time</td>
                    <td>50% of booking value on direct channels (Website)</td>
                </tr>
                <tr>
                    <td>Less than 24 hours before check-in time</td>
                    <td>100% of booking value on direct channels (Website)</td>
                </tr>
                </tbody>
            </Table>
                <h5>Before check-in</h5>
                <p>
                    We will fully refund any booking cancelled up to 48 hours prior to scheduled check in date.
                    For any cancellation within 48 hours of scheduled check-in but before 24 hours, 50%
                    booking amount shall be deducted as cancellation charges. For any cancellation within 24
                    hours of scheduled check-in, the complete booking amount shall be deducted as
                    cancellation charges.
                </p> 
                <h5>On the date of check-in</h5> 
                <p>
                  In case you decide to cancel a booking after scheduled check-in time or do not show up at
                  the hotel, the complete booking amount shall be deducted as cancellation/no show charges.
                </p>
                <h5>Mid Stay Cancellations</h5>
                <p>
                    During your stay, in case you decide to shorten your booking before 12 pm, you will be
                    charged for one night. In case you decide to shorten your booking after 12 pm, you will be
                    charged for next two nights. Money for the remaining nights will be refunded.
                </p>
                <h5>For bookings of 4 or more rooms -</h5>
                <p>
                    You need to pay at least 25% of the booking amount as advance to make a booking for 4 or
                    more rooms.
                </p>
                <Table responsive stripped bordered hover className='Tableur' >
              <thead className='Tableur-head'>
                  <th>Cancellation Time</th>
                  <th>Cancellation Fee</th>
              </thead>
              <tbody>
                <tr>
                    <td>30 days or more prior to check-in date</td>
                    <td>50% advance amount</td>
                </tr>
                <tr>
                    <td>Less than 15 days of check-in date</td>
                    <td>100% advance amount</td>
                </tr>
                
                </tbody>
            </Table>
            <h5>On the date of check-in</h5>
            <p>In case you do not show up at the hotel, no refund is applicable on the booking.</p>
            <h5>Mid Stay Cancellation</h5>
            <p>
              In case you decide to shorten your booking for 4 or more rooms post the check-in date, no
              refund is applicable on the booking.
            </p>
            <h5>How to Cancel</h5>
            <p>
                You can cancel your booking using our website or mobile app. You can also email us at
                info@saishreyasresidency.com to cancel your booking. The applicable refund amount will
                be credited to you within 14 working days.
            </p>
            <h5>Payment Policy</h5>
            <p>
                For bookings of more than 7 nights, guests have to settle all outstanding payments on a
                weekly basis. Hotel will be unable to provide further accommodation prior to settlement of
                the outstanding amount.
            </p>
                  
             
          </div>
        
          
          
          
          
          
          
        </Modal.Body>
        <Modal.Footer>
          <Button className='closeBtn' onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
        </div>
      
    );
  }





export default RefundModal

